module.exports = __webpack_public_path__ + "static/media/tmc-logo-new.6c5d37a5.png";